import React, {useState} from 'react';
import {useTranslation} from "react-i18next";
import styled from "styled-components";
import Images from "../../assets/images/Images";
interface DropdownProps {
    optionsComponent?: React.ReactElement,
    isOpen: boolean,
    displayComponent: React.ReactElement,
    onClose: () => void
}
interface languageProps { value: string, label: string, shortLable: string}

const Blanket: React.FC<{ onClick: () => void }> = (props) => (
    <div style={{ bottom: 0, left: 0, top: 0, right: 0, position: "fixed", zIndex: 1}}
        {...props}
    />
);

const Options: React.FC = (props) => {
    return (
        <div id='options' style={{ position: "relative", zIndex: 2, flex: '1 1 auto', width: '100%' }}
            {...props}
        />
    );
};

const Dropdown: React.FC<DropdownProps> = ({ optionsComponent, isOpen, displayComponent, onClose }) => (
    <div className='dropdown-language-selector'>
        {displayComponent}
        {isOpen ? <Options>{optionsComponent}</Options> : null}
        {isOpen ? <Blanket onClick={onClose} /> : null}
    </div>
);

const ExpandIcon = () => (
    <div style={{display: 'block', margin: 'auto', flex: '1 0 auto'}}>
        <img src={Images.expand} alt="Logo2" style={{height: 10, width: 10, filter: `brightness(0) invert(1)`}} />
    </div>
);


const LanguageOptionDiv = styled.div `
    color: white;
    margin: 0 5px;
    flex: 1 0 auto;

    @media (min-width: 481px) {
        font-size: 18px;
    }

    @media (max-width: 480px) {
        font-size: 12px;
        padding-left: 5px;
    }
`;

const LanguageContainer = styled.div.attrs(props => ({
  // @ts-ignore
  flexDirection: props.flexDirection || 'row'
}))`
    display: flex;
    align-items: flex-end;
    cursor: pointer;

    & .dropdown-language-selector {
        display: flex;
        flex-direction: ${props => props.flexDirection};
    }

    @media (max-width: 480px) {
        padding-right: 5px;
    }
`;

const OptionContainer = styled.div`
    width: inherit;
    display: flex;
    flex-direction: row;
`;

interface Props {
    isReversed?: boolean
}

const LanguageSelector: React.FC<Props> = ({ isReversed = false }) => {
    const { i18n } = useTranslation();
    const getCurrentLng = () => i18n.language || window.localStorage.i18nextLng || 'es';

    const spanish = {value: 'es', label: 'Español', shortLable: 'ES'};
    const english = {value: 'en', label: 'English', shortLable: 'EN'};

    const languages = {
        'es': spanish,
        'en': english
    };

    const [isOpen, setIsOpen] = useState<boolean>(false);
    // @ts-ignore
    const [language, setLanguage] = useState<languageProps>(languages[getCurrentLng()]);


    const toggleOpen = () => {
        setIsOpen(!isOpen)
    };

    const onSelectChange = (language: languageProps) => {
        toggleOpen();
        setLanguage(language);
        i18n.changeLanguage(language.value)
    };

    return (
        <LanguageContainer
            id='languageContainer'
            flexDirection={isReversed ? 'row-reverse' : 'row'}
          >
            <Dropdown
                isOpen={isOpen}
                onClose={toggleOpen}
                displayComponent={
                    <div style={{display: 'flex', flexDirection: 'row', marginBottom: 10, marginRight: 10}} onClick={toggleOpen}>
                        <LanguageOptionDiv>{ language.shortLable }</LanguageOptionDiv>
                        <ExpandIcon />
                    </div>
                }
                optionsComponent={
                    <OptionContainer>
                        <LanguageOptionDiv style={{marginBottom: 10}} onClick={() => onSelectChange(spanish)}>{ spanish.label } </LanguageOptionDiv>
                        <LanguageOptionDiv style={{marginBottom: 10}} onClick={() => onSelectChange(english)}>{ english.label } </LanguageOptionDiv>
                    </OptionContainer>
                }
            />
        </LanguageContainer>
    )
};


export default LanguageSelector;
